import { register } from "../lib/vite-mount";
import { LoginApp } from "../../../../client/app/bundles/Login/startup/LoginApp";

register({ LoginApp });
